import PropTypes from 'prop-types';

export const benchmarkType = PropTypes.shape({
  id: PropTypes.string,
  igAvgImageImpressions: PropTypes.number,
  igAvgImageReach: PropTypes.number,
  igAvgImageEngagements: PropTypes.number,
  igAvgImageLikes: PropTypes.number,
  igAvgImageSaved: PropTypes.number,
  igAvgImageComments: PropTypes.number,
  igAvgImageFollowers: PropTypes.number,
  igAvgImageFollowersEngRate: PropTypes.number,
  igAvgImageReachEngRate: PropTypes.number,
  igAvgVideoImpressions: PropTypes.number,
  igAvgVideoReach: PropTypes.number,
  igAvgVideoEngagements: PropTypes.number,
  igAvgVideoLikes: PropTypes.number,
  igAvgVideoSaved: PropTypes.number,
  igAvgVideoComments: PropTypes.number,
  igAvgVideoViews: PropTypes.number,
  igAvgVideoFollowers: PropTypes.number,
  igAvgVideoFollowersEngRate: PropTypes.number,
  igAvgVideoReachEngRate: PropTypes.number,
  igAvgVideoReachVideoViewsRate: PropTypes.number,
  igAvgStoryImpressions: PropTypes.number,
  igAvgStoryReach: PropTypes.number,
  igAvgStoryTapsForward: PropTypes.number,
  igAvgStoryTapsBack: PropTypes.number,
  igAvgStoryReplies: PropTypes.number,
  igAvgStoryExits: PropTypes.number,
  igAvgStoryFollowers: PropTypes.number,
  igAvgStoryFollowersReachRate: PropTypes.number,
  igAvgFeedImpressions: PropTypes.number,
  igAvgFeedReach: PropTypes.number,
  igAvgFeedEngagements: PropTypes.number,
  igAvgFeedLikes: PropTypes.number,
  igAvgFeedSaved: PropTypes.number,
  igAvgFeedComments: PropTypes.number,
  igAvgFeedFollowers: PropTypes.number,
  igAvgFeedFollowerEngRate: PropTypes.number,
  igAvgFeedReachEngRate: PropTypes.number,
  createdAt: PropTypes.string,
  updatedAt: PropTypes.string,
  ttAvgViews: PropTypes.number,
  ttAvgEngagements: PropTypes.number,
  ttAvgLikes: PropTypes.number,
  ttAvgComments: PropTypes.number,
  ttAvgShares: PropTypes.number,
  ttAvgFollowersEngRate: PropTypes.number,
  ttAvgViewsEngRate: PropTypes.number,
  combinedAudience: PropTypes.shape({
    igFollowersCount: PropTypes.number,
    ttFollowersCount: PropTypes.number,
  }),
  combinedAvgEngagements: PropTypes.shape({
    igAvgEngagements: PropTypes.number,
    ttAvgEngagements: PropTypes.number,
  }),
});
